<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'>
      </el-table-column>
      <el-table-column
        prop= 'organizationId'
        label= '模式所属企业'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>
      <el-table-column
        prop= 'isPublis'
        label= '是否公开'>
      </el-table-column>
      <el-table-column
        prop= 'hotNum'
        label= '点赞数'>
      </el-table-column>
      <el-table-column
        prop= 'growthConditionId'
        label= '种植生长条件'>
      </el-table-column>
      <el-table-column
        prop= 'yieldPerUnitArea'
        label= '亩产'>
      </el-table-column>
      <el-table-column
        prop= 'earliestTimeToMarket'
        label= '最早上市时间'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="模式所属企业" :label-width="formLabelWidth" prop="organizationId">
          <el-input type="number" v-model.number="form.organizationId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth" prop="descr">
          <el-input v-model="form.descr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否公开" :label-width="formLabelWidth" prop="isPublis">
          <el-input type="number" v-model.number="form.isPublis" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="点赞数" :label-width="formLabelWidth" prop="hotNum">
          <el-input type="number" v-model.number="form.hotNum" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="种植生长条件" :label-width="formLabelWidth" prop="growthConditionId">
          <el-input type="number" v-model.number="form.growthConditionId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="亩产" :label-width="formLabelWidth" prop="yieldPerUnitArea">
          <el-input type="number" v-model.number="form.yieldPerUnitArea" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="最早上市时间" :label-width="formLabelWidth" prop="earliestTimeToMarket">
          <el-input v-model="form.earliestTimeToMarket" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        name: null,
        organizationId: null,
        descr: null,
        isPublis: null,
        hotNum: null,
        growthConditionId: null,
        yieldPerUnitArea: null,
        earliestTimeToMarket: null
      },
      rules: {
        organizationId: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        isPublis: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        hotNum: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        growthConditionId: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        yieldPerUnitArea: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        earliestTimeToMarket: [{type: 'date', message: '日期类型不正确', trigger: ['change', 'blur']}]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0
    }
  },
  created () {
    this.query()
  },
  methods: {
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/biotaGrowthModel/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/biotaGrowthModel/listPage?current=${that.current}&pageSize=${that.pageSize}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/biotaGrowthModel/add'
          if (that.form.id) {
            url = '/biotaGrowthModel/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/biotaGrowthModel/Index.vue